import { render, staticRenderFns } from "./DetsisNumarasi.vue?vue&type=template&id=be279480"
import script from "./DetsisNumarasi.vue?vue&type=script&lang=ts"
export * from "./DetsisNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports